// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"269a76bf","455":"2fcdbc8f","952":"fd0cf737","977":"ada91a99"}[chunkId] + ".chunk.js";
};